<div class="liquid-form-area">
    <div class="liquid-form-logo">
        <a href="#"> <img src="assets/images/logo.png" alt="" /> </a>
    </div>
    <div class="liquid-form-heading-text">
        <h4>Welcome back!</h4>
        <p>Please sign in to your account to continue</p>
    </div>
    <div class="liquid-form-content">
        <form [formGroup]="loginForm" (ngSubmit)="login()">
            <!-- single liquid form  -->
            <input
                type="hidden"
                placeholder="Account"
                formControlName="account"
            />
            <div class="single-liquid-form">
                <label for="mail_user">Username</label>
                <input
                    id="mail_user"
                    type="username"
                    placeholder="Username"
                    formControlName="username"
                />
                <div
                    *ngIf="
                        loginForm.controls['username'].touched &&
                        !loginForm.controls['username'].valid
                    "
                >
                    <span
                        *ngIf="
                            loginForm.controls['username'].hasError('required')
                        "
                    >
                        Username is required.
                    </span>
                    <span
                        *ngIf="
                            loginForm.controls['username'].hasError('pattern')
                        "
                    >
                        White space is not allowed.
                    </span>
                    <span
                        *ngIf="
                            loginForm.controls['username'].hasError('minlength')
                        "
                    >
                        Username must be at minimum 3 characters
                    </span>
                </div>
            </div>
            <!-- single liquid form  -->
            <!-- single liquid form  -->
            <div class="single-liquid-form">
                <div class="single-liquid-form-inside">
                    <label for="l_password">Password</label>
                    <a [routerLink]="['/auth/forgot-password']"
                        >Forgot Password?</a
                    >
                </div>
                <input
                    id="l_password"
                    type="password"
                    placeholder="Password"
                    formControlName="password"
                />
                <div
                    *ngIf="
                        loginForm.controls['password'].touched &&
                        !loginForm.controls['password'].valid
                    "
                >
                    <span
                        *ngIf="
                            loginForm.controls['password'].hasError('required')
                        "
                    >
                        Password is required.
                    </span>
                    <span
                        *ngIf="
                            loginForm.controls['password'].hasError('pattern')
                        "
                    >
                        White space is not allowed.
                    </span>
                </div>
            </div>
            <!-- single liquid form  -->
            <div class="liquid-login-form-submit">
                <div id="fast-btn">
                    <button
                        type="submit"
                        [disabled]="loginForm.invalid || isLoader"
                    >
                        <i
                            class="fa fa-circle-o-notch fa-spin"
                            *ngIf="isLoader"
                        ></i>
                        SIGN IN
                    </button>
                </div>
            </div>
        </form>
        <div class="error-message text-center">
            <!---Error Response------>
            <p>{{ loginError }}</p>
        </div>
        <div class="create-account-text">
            <p>
                New on our platform?
                <a [routerLink]="['/auth/signup']">Create an account</a>
            </p>
        </div>
    </div>
</div>
